import { KasasaAccountUpgradeFromAccountProductCode, KasasaUpgrade, KasasaUpgradeTableItem } from '@/api/kasasaupgrade';
import { ProductMapping } from '@/api/productmapping';
import DateTool from '@/util/DateTool';
import { DisplayProduct } from './DisplayProduct';
import { DisplayAccountProductCode } from './DisplayAccountProductCode';

export default class KasasaAccountUpgradeUtil {
  public static buildProductListsForSelect(products:ProductMapping[],
    toKasasaProducts: DisplayProduct[], fromNonKasasaProducts: DisplayAccountProductCode[]) {
    products.forEach((product:ProductMapping) => {
      if (!product.kasasaPowered && (product.accountType === 'DDA' || product.accountType === 'SAV')) {
        for (let i = 0; i < product.coreAccountProductTypes.length; i++) {
          const coreAccountProduct = product.coreAccountProductTypes[i];
          const nonKasasaDisplayAccountProductCode: DisplayAccountProductCode = {
            displayName: `${product.fiProductName} - ${product.accountType} - ${coreAccountProduct.coreProductCode}`,
            accountProductCode: KasasaAccountUpgradeFromAccountProductCode.from({
              coreAccountType: coreAccountProduct.coreAccountType!,
              coreProductCode: coreAccountProduct.coreProductCode!,
              externalProductMappingId: product.externalProductMappingId!,
            }),
          };
          fromNonKasasaProducts.push(nonKasasaDisplayAccountProductCode);
        }
      }

      if (product.kasasaPowered && (product.productType === 'KASASA_CASH' || product.productType === 'KASASA_CASH_BACK' || product.productType === 'KASASA_REWARDS')) {
        const kasasaDisplayProduct: DisplayProduct = {
          displayName: product.fiProductName!,
          externalProductMappingId: product.externalProductMappingId!,
        };
        toKasasaProducts.push(kasasaDisplayProduct);
      }
    });
  }

  public static buildProductMap(productMappings:ProductMapping[], productMap: Map<number, ProductMapping>) {
    productMappings.forEach((productMapping:ProductMapping) => {
      productMap.set(productMapping.externalProductMappingId!, productMapping);
    });
  }

  public static buildKasasaUpgradeTableItems(kasasaUpgrades: KasasaUpgrade[], productMap: Map<number, ProductMapping>, kasasaUpgradeTableItems: KasasaUpgradeTableItem[]) {
    kasasaUpgradeTableItems.splice(0, kasasaUpgradeTableItems.length);
    kasasaUpgrades.forEach((upgrade: KasasaUpgrade) => {
      kasasaUpgradeTableItems.push(
        {
          id: upgrade.id,
          fiId: upgrade.fiId,
          startDate: upgrade.startDate,
          endDate: upgrade.endDate,
          fromNonKasasaProductItems: KasasaAccountUpgradeUtil.buildNonKasasaProductItems(upgrade, productMap),
          toKasasaProductItems: KasasaAccountUpgradeUtil.buildKasasaProductItems(upgrade, productMap),
          upgrade,
        },
      );
    });
  }

  static buildNonKasasaProductItems(upgrade:KasasaUpgrade, productMap: Map<number, ProductMapping>) : string[] {
    const buffer: string[] = [];
    for (let i = 0; i < upgrade.fromAccountProductCodes.length; i++) {
      const accountProductCode:KasasaAccountUpgradeFromAccountProductCode = upgrade.fromAccountProductCodes[i];
      const productMapping: ProductMapping | undefined = productMap.get(accountProductCode.externalProductMappingId);
      const productName: string | undefined = productMapping ? productMapping.fiProductName : '?';
      buffer.push(`${productName} - ${accountProductCode.coreAccountType} - ${accountProductCode.coreProductCode}`);
    }
    return buffer;
  }

  static buildKasasaProductItems(upgrade:KasasaUpgrade, productMap: Map<number, ProductMapping>) : string[] {
    const buffer: string[] = [];
    for (let i = 0; i < upgrade.toKasasaProducts.length; i++) {
      const product:ProductMapping | undefined = productMap.get(upgrade.toKasasaProducts[i]);
      buffer.push(product ? product!.fiProductName : '?');
    }
    return buffer;
  }

  public static validateEndDateIsOnOrAfterStartEndDate(value: any, startDateString: string | null) : boolean | string {
    if (value && value.length !== 0 && startDateString && startDateString.length !== 0) {
      const endDate:Date = new Date(value);
      const startDate:Date = DateTool.parseDate(startDateString);

      if (startDate.getTime() > endDate.getTime()) {
        return 'End Date must be on after Start Date';
      }
    }

    return true;
  }

  public static validateStartDateIsOnOrBeforeEndDate(value: any, endDateString: string | null) : boolean | string {
    if (value && value.length !== 0 && endDateString && endDateString.length !== 0) {
      const startDate:Date = new Date(value);
      const endDate:Date = DateTool.parseDate(endDateString);

      if (startDate.getTime() > endDate.getTime()) {
        return 'Start Date must be on before End Date';
      }
    }

    return true;
  }
}
